import { CvpLocale } from "../constants/CvpLocale";
import { LocContext } from "./LocContext";

export async function getTranslationMap(
  stringContext: LocContext,
  locale: CvpLocale
): Promise<{ [key: string]: any }> {
  if (stringContext === LocContext["[Translations no longer in use]"]) {
    return {};
  }

  if (stringContext === LocContext.ADMIN) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/admin.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/admin.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/admin.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/admin.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/admin.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/admin.json")).default;
    }
  }

  if (stringContext === LocContext.CV) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/cv.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/cv.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/cv.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/cv.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/cv.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/cv.json")).default;
    }
  }

  if (stringContext === LocContext.GENERAL) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/general.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/general.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/general.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/general.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/general.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/general.json")).default;
    }
  }

  if (stringContext === LocContext.JOB) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/job.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/job.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/job.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/job.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/job.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/job.json")).default;
    }
  }

  if (stringContext === LocContext.JOBS) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/jobs.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/jobs.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/jobs.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/jobs.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/jobs.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/jobs.json")).default;
    }
  }

  if (stringContext === LocContext.PROFILE) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/profile.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/profile.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/profile.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/profile.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/profile.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/profile.json")).default;
    }
  }

  if (stringContext === LocContext.WORKSCHEDULE) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/workschedule.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/workschedule.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/workschedule.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/workschedule.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/workschedule.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/workschedule.json")).default;
    }
  }

  if (stringContext === LocContext.MESSAGES) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/messages.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/messages.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/messages.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/messages.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/messages.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/messages.json")).default;
    }
  }

  if (stringContext === LocContext.TIMESHEETS) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/timesheets.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/timesheets.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/timesheets.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/timesheets.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/timesheets.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/timesheets.json")).default;
    }
  }

  if (stringContext === LocContext.PRIME) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/prime.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/prime.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/prime.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/prime.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/prime.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/prime.json")).default;
    }
  }

  if (stringContext === LocContext.PRIVACY) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/privacy.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/privacy.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/privacy.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/privacy.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/privacy.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/privacy.json")).default;
    }
  }

  if (stringContext === LocContext.ERROR) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/error.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/error.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/error.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/error.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/error.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/error.json")).default;
    }
  }

  if (stringContext === LocContext.TYPES) {
    if (locale === CvpLocale.da) {
      return (await import("./translated-by-gpt/da/types.json")).default;
    }
    if (locale === CvpLocale["sv"]) {
      return (await import("./translated-by-gpt/sv/types.json")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("./translated-by-gpt/pl/types.json")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("./translated-by-gpt/de/types.json")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("./translated-by-gpt/fr/types.json")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("./translated-by-gpt/en/types.json")).default;
    }
  }

  throw new Error(
    `No translations for context/locale: ${stringContext}/${locale}`
  );
}
